// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo .icon-logo {\n  display: inline-block;\n  width: 90px;\n  object-fit: cover;\n}\n\ni {\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
